import React from 'react';
import styled from 'styled-components';

import Image from 'partials/Image';
import Container from 'partials/Container';
import AnimateIn from 'partials/AnimateIn';

export default props => {
    const { image, credit } = props.data;
    const pageBackground = props.page && props.page.acf && props.page.acf.page_background ? props.page.acf.page_background : 'white';

    if(!image) return null;

    return (
        <Wrapper pageBackground={pageBackground}>
            <AnimateIn>
                <Container>
                    <Image image={image} />
                    {credit && <p className="credit">Foto: {credit}</p>}
                </Container>
            </AnimateIn>
        </Wrapper>
    );
}

const Wrapper = styled.article`
    margin-bottom:60px;
    @media (max-width: 768px) {
        margin-bottom:40px;
    }

    .credit {
        text-align: right;
        font-size: 12px;
        padding-top: 5px;
        ${props => props.pageBackground === 'main' ? `
            color: white;
        ` : ``}
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/Image.js